<template>
<div class="activitiesold">
    <div style="padding-top:5%; ">
        <!-- <div class="page-header"> -->
        <div>
            <h1>【2019】各校OA活動列表</h1>
        </div>
        <b-container style="margin-top:0px auto; padding-top:2%; font-size:20px;!important">
            <div class="panel panel-default tb">
                <div class="panel-body">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th>活動名稱</th>
                                <th>活動時間</th>
                                <th>主辦單位</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="ac in oaActivities" :key="ac">
                                <td><a v-bind:href="ac.url">{{ac.activity_name}}</a></td>
                                <!-- <td><a v-bind:href="ac.url">{{todo.name}}</a></td> -->
                                <td>{{ac.date[0] }} - {{ac.date[1]}}</td>
                                <td>{{ac.host}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </b-container>
    </div>
</div>
</template>
<script>
import { db } from '../main'
export default {
  name: 'activitiesOld',
  data () {
    return {
      oaActivities: []
    }
  },
  firestore () {
    return {
      oaActivities: db.collection('oaActivities').where('startdate', '==', '')
    }
  }
}
</script>
<style scoped>
.collapse-item {
    overflow: hidden;
    height: 0;
    padding: 0;
    transition: height .5s;
}

/*#collapse-1{
  position: relative;
  height: 0;
  overflow: show;
  @include transition($transition-collapse);
}*/
span {
    font-family: Microsoft JhengHei;
    font-size: 16px;
    font-weight: bold;
}

.activitiesold {
    padding-top: 20px;
    background-color: rgba(248, 194, 88, 0.1);
    box-shadow: 0 5px 5px -2px rgba(0, 0, 0, .2);
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    /* padding-bottom: 5%; */
}
.tb {
    margin-top: 3%;
    /* margin-left:5%;
    margin-right:5%;  */
    background-color: white 0.5;
    border-radius: 10px;
    box-shadow: 0 0 5px #000;
    width: 105%;
}
@media only screen and (max-width: 600px) {
    table {white-space: inherit; }
    .tb {width:105%;}
    .activitiesold {padding-bottom: 160px;}
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
    table {white-space: inherit;}
    .activitiesold {padding-bottom: 150px;}
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
   table {white-space: inherit;}
   .activitiesold {padding-bottom: 350px;}
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
    table {white-space: inherit;}
    .activitiesold {padding-bottom: 150px;}
}
@media only screen and (min-width: 790px) {
   table {white-space: inherit;}
   .activities {padding-bottom: 550px;}
}
/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
    .activities {padding-bottom: 50px;}
    table {white-space:inherit;}
}
th {
    font-size: 18px;
    font-weight: 500;
}
tr {
    font-size: 20px!important;
    font-weight: 500!important;
}
label {
    font-weight:400;
    font-size:large;
}

table td {
    font-size: 16px!important;
    font-weight: 400!important;
}
</style>
